import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMicrosoftTeams = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	id: "Livello_1",
	x: 0,
	y: 0,
	style: { enableBackground: "new 0 0 2228.83 2073.33" },
	viewBox: "0 0 2228.83 2073.33",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", { children: ".st0{fill:#5059c9}.st1{fill:#7b83eb}.st2,.st3{opacity:.1;enable-background:new}.st3{opacity:.2}" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M1554.64 777.5h575.71c54.39 0 98.48 44.09 98.48 98.48v524.4c0 199.9-162.05 361.95-361.95 361.95h-1.71c-199.9.03-361.97-162-362-361.9V828.97c0-28.43 23.04-51.47 51.47-51.47z",
			className: "st0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1943.75,
			cy: 440.58,
			r: 233.25,
			className: "st0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1218.08,
			cy: 336.92,
			r: 336.92,
			className: "st1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1667.32 777.5H717.01c-53.74 1.33-96.26 45.93-95.01 99.68v598.1c-7.51 322.52 247.66 590.16 570.17 598.05 322.51-7.89 577.67-275.53 570.17-598.05v-598.1c1.24-53.75-41.27-98.35-95.02-99.68z",
			className: "st1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1244 777.5v838.15c-.26 38.44-23.55 72.96-59.09 87.6a91.96 91.96 0 0 1-35.77 7.26H667.61c-6.74-17.1-12.96-34.21-18.14-51.83A631.45 631.45 0 0 1 622 1475.19V877.02c-1.25-53.66 41.2-98.19 94.85-99.52H1244z",
			className: "st2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1192.17 777.5v889.98a91.78 91.78 0 0 1-7.26 35.77c-14.63 35.54-49.16 58.83-87.6 59.09H691.97c-8.81-17.1-17.1-34.21-24.36-51.83s-12.96-34.21-18.14-51.83A631.45 631.45 0 0 1 622 1475.19V877.02c-1.25-53.66 41.2-98.19 94.85-99.52h475.32z",
			className: "st3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1192.17 777.5v786.31c-.4 52.22-42.63 94.46-94.85 94.85H649.47A631.45 631.45 0 0 1 622 1475.17V877.02c-1.25-53.66 41.2-98.19 94.85-99.52h475.32z",
			className: "st3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1140.33 777.5v786.31c-.4 52.22-42.63 94.46-94.85 94.85H649.47A631.45 631.45 0 0 1 622 1475.17V877.02c-1.25-53.66 41.2-98.19 94.85-99.52h423.48z",
			className: "st3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1244 509.52V672.8c-8.81.52-17.1 1.04-25.92 1.04s-17.1-.52-25.92-1.04c-17.5-1.16-34.85-3.94-51.83-8.29-104.96-24.86-191.68-98.47-233.25-198a288.083 288.083 0 0 1-16.59-51.83h258.65c52.31.19 94.66 42.54 94.86 94.84z",
			className: "st2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1192.17 561.35V672.8c-17.5-1.16-34.85-3.94-51.83-8.29-104.96-24.86-191.68-98.47-233.25-198h190.23c52.3.19 94.65 42.54 94.85 94.84z",
			className: "st3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1192.17 561.35V672.8c-17.5-1.16-34.85-3.94-51.83-8.29-104.96-24.86-191.68-98.47-233.25-198h190.23c52.3.19 94.65 42.54 94.85 94.84z",
			className: "st3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1140.33 561.35V664.5c-104.96-24.86-191.68-98.47-233.25-198h138.4c52.3.2 94.65 42.55 94.85 94.85z",
			className: "st3"
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "SVGID_1_",
			x1: 198.099,
			x2: 942.233,
			y1: -1123.072,
			y2: 165.738,
			gradientTransform: "translate(0 1515.333)",
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					style: { stopColor: "#5a62c3" }
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					style: { stopColor: "#4d55bd" }
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					style: { stopColor: "#3940ab" }
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.01 466.5h950.31c52.47 0 95.01 42.54 95.01 95.01v950.31c0 52.47-42.54 95.01-95.01 95.01H95.01c-52.47 0-95.01-42.54-95.01-95.01V561.51c0-52.47 42.54-95.01 95.01-95.01z",
			style: { fill: "url(#SVGID_1_)" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M820.21 828.19H630.24v517.3H509.21v-517.3H320.12V727.84h500.09v100.35z",
			style: { fill: "#fff" }
		})
	]
});
export default SvgIconMicrosoftTeams;
